// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__oWWFT","truncatedText":"styles_truncatedText__M6RLG","fullText":"styles_fullText__bxB7p","textContainer":"styles_textContainer__4bUWg"};